import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  min-height: 850px;
  padding: 24px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  justify-content: center;
  align-items: center;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const WrapperFilter = styled.div`
  padding-top: 10px;
  margin-bottom: 20px;
  display: flex;
  gap: 16px;
  overflow-x: scroll;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const WrapperDataGrid = styled.div`
  height: 630px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

export const ImageNoData = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

export const ImageNotFound = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

export const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

export const WrapperStatusRefund = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 8px;
`;

export const WrapperMobileButton = styled.div`
  display: ${({ isSmallerThanTablet }) =>
    isSmallerThanTablet ? "flex" : "none"};
  justify-content: space-between;
  gap: 8px;
`;
